import { faTimes } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useRef, useState } from "react"
import { Button, Dropdown, Modal } from "react-bootstrap"
import { toast } from "sonner"
import { GetRequest, PostRequest, PutRequest } from "../Utils/hooks/ApiHandler"
import useLocalStorageState from "use-local-storage-state"
import { useNavigate } from "react-router-dom"
import { IconArrowNarrowLeft, IconCheck, IconChevronCompactDown, IconDotsVertical, IconDownloadOff, IconEye, IconPencil, IconShare3, IconTrash, IconUser, IconUserCircle, IconUserPlus, IconUsers, } from "@tabler/icons-react"
import { useOutsideClickHandler } from "../Utils/hooks/useOutsideClickHandler"

export const PipelineShareModal = ({ shareModal, module_name, onShareClose, pipelineId, sharedUsers }) => {
    const [customer, setCustomer] = useLocalStorageState("customer")

    const token = customer?.token?.authorization;
    const rf = customer?.token?.authentication;

    const headers = {
        Authorization: token,
        Authentication: rf,
    };
    const navigate = useNavigate();
    const extras = { customer, setCustomer, rf, navigate };

    // email recipients state
    const [emailRecipients, setEmailRecipients] = useState([])
    const [currentEmailInput, setCurrentEmailInput] = useState("")
    const [emailInputTouched, setEmailInputTouched] = useState(false)

    const [showEmailDropdown, setShowEmailDropdown] = useState(false)
    const [showPermissionsDrop, setShowPermissionsDrop] = useState(false)
    const permissionsDropRef = useRef(null)

    const useOutsideClick = (ref, isOpen, onClose) => {
        useEffect(() => {
            if (!isOpen) return;

            const handleClickOutside = (event) => {
                if (ref.current && !ref.current.contains(event.target)) {
                    onClose();
                }
            };

            document.addEventListener("mousedown", handleClickOutside);

            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref, isOpen, onClose]);
    };
    useOutsideClick(permissionsDropRef, showPermissionsDrop, () => setShowPermissionsDrop(false))
    const [selectedPermission, setSelectedPermission] = useState("")

    // state for multistage form
    const [shareForm, setShareForm] = useState(true)

    // states for storing the email search based on which api would get called
    const [emailSearchInput, setEmailSearchInput] = useState("")
    const [debounceEmailSearchInput, setDebounceEmailSearchInput] = useState("")

    // sharing state on form submission
    const [isSharing, setSharing] = useState(false)
    // for opening the view, edit, download dropdown with respect to each user
    const [openDropdown, setOpenDropdown] = useState(false)
    // users to whom as an owner i alloted permissions / existing users to whom permission is being assigned
    const [users, setUsers] = useState(sharedUsers === null ? [] : sharedUsers)

    // to store the current user email input (only the user object)
    const [emailOptions, setEmailOptions] = useState(null)
    const [isLoadingEmails, setIsLoadingEmails] = useState(false)

    const [selectedUsers, setSelectedUsers] = useState([...users])
    // ref for email dropdown
    const emailDropdownRef = useRef(null)
    // useeffect for outside click of the email dropdown modal
    useOutsideClickHandler({
        objRef: emailDropdownRef,
        isDropdown: showEmailDropdown,
        setDropdown: setShowEmailDropdown
    })

    // to validate email format
    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return emailRegex.test(email)
    }


    //  Handle email input for tag system
    const handleEmailInputKeyDown = (e) => {
        if (e.key === "Enter" || e.key === ",") {
            e.preventDefault()
            setEmailInputTouched(true)
            addEmailTag()
        }
    }

    const handleEmailInputChange = (e) => {
        const value = e.target.value
        setCurrentEmailInput(value)
        setEmailSearchInput(value)

        // Show dropdown when user starts typing
        if (value.length > 0) {
            setShowEmailDropdown(true)
        } else {
            setShowEmailDropdown(false)
        }
    }

    // Add email tag with validation

    const addEmailTag = (emailToAdd = null) => {
        const emailValue = emailToAdd || currentEmailInput.trim()

        if (emailValue && !emailRecipients.includes(emailValue)) {
            // basic email validation for manually input emails
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

            if (emailRegex.test(emailValue)) {
                setEmailRecipients((prev) => [...prev, emailValue])

                const selected = emailOptions?.find(
                    (c) => c.email === emailValue
                )

                if (selected) {
                    setSelectedUsers((prev) => [...prev, selected])
                    setEmailOptions((prev) => prev?.filter((user) => user.email !== emailValue))
                }
                setCurrentEmailInput("")
                setShowEmailDropdown(false)
            } else {
                toast.warning("Please enter a valid email address")
            }
        }
    }
    // const addEmailTag = (emailToAdd = null) => {
    //     const emailValue = emailToAdd || currentEmailInput.trim()
    //     if (emailValue && !emailRecipients.includes(emailValue)) {
    //         // Basic email validation
    //         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    //         if (emailRegex.test(emailValue)) {
    //             setEmailRecipients((prev) => [...prev, emailValue])
    //             const selected = emailOptions?.filter(c => c.email === emailToAdd)
    //             setSelectedUsers((prev) => ([...prev, ...selected]))
    //             // setEmailOptions((prev) => prev?.filter((user) => user.email !== emailValue))
    //             setCurrentEmailInput("")
    //             setShowEmailDropdown(false)
    //         } else {
    //             toast.warning("Please enter a valid email address")
    //         }
    //     }
    // }
    console.log("selectedUsers", selectedUsers)
    // Remove email tag
    const removeEmailTag = (emailToRemove) => {
        setEmailRecipients((prev) => prev.filter((email) => email !== emailToRemove))
    }

    const fetchUsers = async () => {
        try {
            const res = await GetRequest(`lead/user_sharedToList/${customer.customer_details?.customer_id}/${customer.customer_details?.id}/${pipelineId}`, { headers }, extras)
            if (res.status === "fail" || res.success === false) {
                return
            }
            setEmailOptions(res.data)
        } catch (error) {
            return
        }
    }
    useEffect(() => {
        fetchUsers()
    }, [])

    const [permissionSelected, setPermissionSelected] = useState(false)
    const handleSubmit = async () => {
        try {
            // filtered users would be the array of object of new users to whom permission is being assigned
            const filteredUsers = selectedUsers?.length !== 0 && selectedUsers?.map(c => ({
                ...c, permissions: [{
                    can_view: selectedPermission === "view" ? true : false,
                    can_edit: selectedPermission === "edit" ? true : false,
                    can_download: selectedPermission === "download" ? true : false,
                }]
            }));
            const payload = {
                pipeline_id: pipelineId,
                customer_id: customer.customer_details?.customer_id,
                module_name: module_name,
                user_login_id: customer?.customer_details?.id,
                users: [...users, ...filteredUsers]
            }
            console.log('filteredUsers', filteredUsers)
            if (shareForm && selectedPermission.trim().length === 0) {
                toast.warning("Please select atleast one permission!")
                setShowPermissionsDrop(true)
                return
            }
            setPermissionSelected(false)
            setSharing(true)
            const res = await PutRequest(`lead/sharePipeline/${customer.customer_details?.customer_id}/${customer.customer_details?.id}`, payload, { headers }, extras)
            if (res.status === "fail" || res.success === false) {
                return
            }
            onShareClose()
            setSelectedPermission("")
            toast.success(res.message)
        } catch (error) {
            return
        } finally {
            setSharing(false)
        }
    }
    const handleRemoveAccess = async (updatedUsers) => {
        try {
            const payload = {
                pipeline_id: pipelineId,
                customer_id: customer.customer_details?.customer_id,
                module_name: module_name,
                users: updatedUsers?.length === 0 && null,
                user_login_id: customer.customer_details?.id
            };

            setSharing(true);

            const res = await PutRequest(
                `lead/sharePipeline/${customer.customer_details?.customer_id}/${customer.customer_details?.id}`,
                payload,
                { headers },
                extras
            );

            if (res.status === "fail" || res.success === false) return;
            await fetchUsers()
            toast.success(res.message);
        } catch (err) {
            return;
        } finally {
            setSharing(false);
        }
    };


    // const updatePermission = (id, selected) => {
    //     setSelectedPermission(selected)
    //     setUsers(prev =>
    //         prev.map(user =>
    //             user.id === id
    //                 ? {
    //                     ...user,
    //                     permissions: [
    //                         {
    //                             can_view: selected === "view",
    //                             can_edit: selected === "edit",
    //                             can_download: selected === "download"
    //                         }
    //                     ]
    //                 }
    //                 : user
    //         )
    //     );
    //     setTimeout(() => {
    //         handleSubmit();
    //     }, 100);
    // };
    const updatePermission = async (id, selected) => {
        setSelectedPermission(selected)

        const updatedUsers = users.map(user =>
            user.id === id
                ? {
                    ...user,
                    permissions: [
                        {
                            can_view: selected === "view",
                            can_edit: selected === "edit",
                            can_download: selected === "download"
                        }
                    ]
                }
                : user
        );

        setUsers(updatedUsers)

        try {
            setSharing(true)

            const payload = {
                pipeline_id: pipelineId,
                customer_id: customer.customer_details?.customer_id,
                module_name: module_name,
                user_login_id: customer?.customer_details?.id,
                users: updatedUsers
            }

            const res = await PutRequest(
                `lead/sharePipeline/${customer.customer_details?.customer_id}/${customer.customer_details?.id}`,
                payload,
                { headers },
                extras
            )

            if (res.status === "fail" || res.success === false) {
                return
            }

            toast.success(res.message)
        } catch (error) {
            return
        } finally {
            setSharing(false)
        }
    };
    const getSelectedPermission = (permObj) => {
        if (permObj.can_view) return "view";
        if (permObj.can_edit) return "edit";
        if (permObj.can_download) return "download";
        return null;
    };

    return (
        <Modal
            centered
            show={shareModal}
            onHide={onShareClose}
            contentClassName="border-0 shadow-lg rounded-3"
        >
            <Modal.Header closeButton className="border-bottom-0 pt-4 px-4 align-items-start">
                <div className="d-flex flex-column">
                    <div className="d-flex align-items-start mb-1 gap-2">
                        <div
                            className="d-flex align-items-center justify-content-center rounded-2"
                            style={{
                                background: "linear-gradient(135deg, #7a3a5e 0%, #4f243c 100%)",
                                width: "38px",
                                height: "38px",
                                boxShadow: "0 4px 10px rgba(122, 58, 94, 0.2)"
                            }}
                        >
                            <IconUsers stroke={2} size={20} color="white" />
                        </div>
                        <div className="d-flex flex-column">
                            <Modal.Title className="h5 fw-bold m-0" style={{ color: '#1a202c' }}>
                                Share Pipeline
                            </Modal.Title>
                            <small className="text-muted ">
                                {shareForm ? "Invite team members to collaborate on this pipeline." : "Manage existing access and permissions."}
                            </small>
                        </div>
                    </div>
                </div>
            </Modal.Header>

            {/* --- ORIGINAL BODY CONTENT (UNTOUCHED) --- */}
            <Modal.Body className="d-flex align-items-center gap-2 px-4 py-3">
                {shareForm && (
                    <>
                        <div className="mb-3 position-relative" style={{ width: "28rem" }}>
                            <label className="form-label">
                                Invitees <span className="text-danger">*</span>
                            </label>
                            <div
                                className="border rounded p-2"
                                style={{ minHeight: "40px", cursor: "text" }}
                                onClick={() => document.getElementById("email-input").focus()}
                            >
                                <div
                                    onClick={() => setShowEmailDropdown(true)}
                                    className="d-flex flex-wrap gap-1 align-items-center"
                                >
                                    {emailRecipients?.map((e, index) => (
                                        <span
                                            key={index}
                                            className="badge bg-primary d-flex align-items-center gap-1"
                                            style={{ fontSize: "12px", padding: "4px 8px" }}
                                        >
                                            {e}
                                            <FontAwesomeIcon
                                                icon={faTimes}
                                                style={{ cursor: "pointer", fontSize: "10px" }}
                                                onClick={() => removeEmailTag(e)}
                                            />
                                        </span>
                                    ))}
                                    <input
                                        id="email-input"
                                        type="text"
                                        className="border-0 flex-grow-1"
                                        style={{ outline: "none", minWidth: "200px", background: "transparent" }}
                                        placeholder={emailRecipients?.length === 0 ? "Press ENTER to add email..." : "Add more emails..."}
                                        value={currentEmailInput}
                                        onChange={handleEmailInputChange}
                                        onKeyDown={handleEmailInputKeyDown}
                                        onFocus={() => currentEmailInput?.length > 0}
                                    />
                                </div>
                            </div>

                            {showEmailDropdown && (
                                <div
                                    className="position-absolute w-100 bg-white border rounded shadow-sm mt-1"
                                    style={{ zIndex: 1000, maxHeight: "300px", overflowY: "auto" }}
                                    ref={emailDropdownRef}
                                >
                                    {isLoadingEmails ? (
                                        <div className="p-3 text-center text-muted">
                                            <small>Loading emails...</small>
                                        </div>
                                    ) : (
                                        <>
                                            {emailOptions?.length > 0 &&
                                                emailOptions.map((contact) => (
                                                    <div
                                                        key={contact.id}
                                                        className="px-3 py-2 hover-bg-light cursor-pointer border-bottom"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => addEmailTag(contact?.email)}
                                                        onMouseEnter={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
                                                        onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
                                                    >
                                                        <div className="d-flex align-items-center">
                                                            <div>
                                                                <div style={{ fontSize: "14px", fontWeight: "500" }}>
                                                                    {contact.user_full_name}
                                                                </div>
                                                                <small className="text-muted">{contact.email}</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}

                                            {(emailOptions?.length === 0 || emailOptions?.length === undefined) && !isLoadingEmails && (
                                                <div className="p-3 text-center text-muted" style={{ height: "fit" }}>
                                                    <small>No emails found. Type to search or press Enter to add manually.</small>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                        <Dropdown className="dropdownsWithoutToggle" style={{ height: '1rem' }} as="div" align="end" show={showPermissionsDrop} ref={permissionsDropRef}>
                            <Dropdown.Toggle
                                as="span"
                                onClick={() => setShowPermissionsDrop(!showPermissionsDrop)}
                                className="border rounded-2 d-flex justify-content-center align-items-center bg-light hover-bg-light transition-all"
                                style={{
                                    cursor: "pointer",
                                    width: "42px",
                                    height: "42px",
                                    border: "1px solid #dee2e6"
                                }}
                            >
                                <IconChevronCompactDown stroke={2} size={20} color="#64748b" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                                className="shadow-lg border-0 rounded-3 py-2 dropdown-menu-end"
                                style={{ width: "240px", marginTop: "8px" }}
                            >
                                <style jsx>
                                    {`
                                        .dropdown-permission-item {
                                            padding: 10px 16px;
                                            transition: all 0.2s ease;
                                        }
                                        .dropdown-permission-item:hover {
                                            background-color: #f8f9fa;
                                        }
                                        .dropdown-permission-item.active {
                                            background-color: rgba(122, 58, 94, 0.05) !important;
                                            color: #7a3a5e !important;
                                        }
                                        .tick-slot {
                                            width: 24px;
                                            display: flex;
                                            justify-content: center;
                                            align-items: center;
                                            color: #7a3a5e;
                                        }
                                        .permission-icon-box {
                                            color: #64748b;
                                        }
                                        .active .permission-icon-box {
                                            color: #7a3a5e;
                                        }
                                    `}
                                </style>

                                {/* View Permission */}
                                <Dropdown.Item
                                    active={selectedPermission === "view"}
                                    onClick={() => { setSelectedPermission("view"); setShowPermissionsDrop(false); }}
                                    className="d-flex align-items-start gap-2 dropdown-permission-item"
                                >
                                    <div className="tick-slot">
                                        {selectedPermission === "view" && <IconCheck size={18} stroke={3} />}
                                    </div>
                                    <div className="permission-icon-box pt-1">
                                        <IconEye stroke={2} size={18} />
                                    </div>
                                    <div className="d-flex flex-column align-items-start">
                                        <span className="fw-bold" style={{ fontSize: '13px' }}>Can View</span>
                                        <small className="text-muted" style={{ fontSize: '11px' }}>Read-only access to pipeline.</small>
                                    </div>
                                </Dropdown.Item>

                                {/* Edit Permission */}
                                <Dropdown.Item
                                    active={selectedPermission === "edit"}
                                    onClick={() => { setSelectedPermission("edit"); setShowPermissionsDrop(false); }}
                                    className="d-flex align-items-start gap-2 dropdown-permission-item"
                                >
                                    <div className="tick-slot">
                                        {selectedPermission === "edit" && <IconCheck size={18} stroke={3} />}
                                    </div>
                                    <div className="permission-icon-box pt-1">
                                        <IconPencil stroke={2} size={18} />
                                    </div>
                                    <div className="d-flex flex-column align-items-start">
                                        <span className="fw-bold" style={{ fontSize: '13px' }}>Can Edit</span>
                                        <small className="text-muted" style={{ fontSize: '11px' }}>Can modify leads and stages.</small>
                                    </div>
                                </Dropdown.Item>

                                {/* Download Restriction */}
                                <Dropdown.Item
                                    active={selectedPermission === "download"}
                                    onClick={() => { setSelectedPermission("download"); setShowPermissionsDrop(false); }}
                                    className="d-flex align-items-start gap-2 dropdown-permission-item"
                                >
                                    <div className="tick-slot">
                                        {selectedPermission === "download" && <IconCheck size={18} stroke={3} />}
                                    </div>
                                    <div className="permission-icon-box pt-1">
                                        <IconDownloadOff stroke={2} size={18} />
                                    </div>
                                    <div className="d-flex flex-column align-items-start">
                                        <span className="fw-bold" style={{ fontSize: '13px' }}>Can't Download</span>
                                        <small className="text-muted" style={{ fontSize: '11px' }}>Full access, but export disabled.</small>
                                    </div>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </>
                )}
                {!shareForm && (
                    <div>
                        <div onClick={() => setShareForm(true)} className="d-flex gap-1 align-items-center btn btn-default-outline " style={{ cursor: "pointer", border: '1px solid grey', borderRadius: '3px', width: "max-content", padding: '5px', fontSize: '0.9rem' }}> <IconArrowNarrowLeft size={16} stroke={2} /> Back</div>
                        <hr style={{ width: "29rem" }} />
                        {users !== null && users?.length !== 0 && users?.map(user => {
                            const permObj = user.permissions[0];
                            const selected = getSelectedPermission(permObj);
                            return (
                                <div key={user.id} className="d-flex align-items-start justify-content-between current mb-2" style={{ padding: "0.5rem", borderRadius: "5px" }}>
                                    <div className="d-flex gap-1">
                                        <IconUser size={18} stroke={2} style={{ backgroundColor: "#f0f0f0", width: 28, height: 28, borderRadius: "50%", padding: "3px", paddingTop: "5px", marginTop: "3px" }} />
                                        <div className="d-flex flex-column">
                                            <div style={{ fontSize: '0.8rem' }}>{user?.user_full_name}</div>
                                            <small style={{ fontSize: "0.6rem" }}>{user.email}</small>
                                        </div>
                                    </div>
                                    <Dropdown
                                        className="dropdownsWithoutToggle"
                                        as="div"
                                        align="end"
                                        show={openDropdown === user.id}
                                    >
                                        <Dropdown.Toggle
                                            as="div"
                                            onClick={() => setOpenDropdown(openDropdown === user.id ? null : user.id)}
                                            style={{
                                                display: "flex",
                                                backgroundColor: openDropdown === user.id ? "rgba(122, 58, 94, 0.1)" : "#f0f0f0",
                                                color: openDropdown === user.id ? "#7a3a5e" : "#64748b",
                                                cursor: "pointer",
                                                width: 32,
                                                height: 32,
                                                borderRadius: "50%",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                transition: "all 0.2s ease"
                                            }}
                                        >
                                            <IconDotsVertical size={18} />
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu
                                            className="shadow-lg border-0 rounded-3 py-2 dropdown-menu-end"
                                            style={{ width: "220px", marginTop: "8px" }}
                                        >
                                            <style jsx>
                                                {`
                .dropdown-permission-item {
                    padding: 10px 16px;
                    transition: all 0.2s ease;
                }
                .dropdown-permission-item:hover {
                    background-color: #f8f9fa;
                }
                .dropdown-permission-item.active {
                    background-color: rgba(122, 58, 94, 0.05) !important;
                    color: #7a3a5e !important;
                }
                .tick-slot {
                    width: 24px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: #7a3a5e;
                }
            `}
                                            </style>

                                            {/* View Option */}
                                            <Dropdown.Item
                                                active={selected === "view"}
                                                onClick={() => {
                                                    updatePermission(user.id, "view");
                                                    setOpenDropdown(null);
                                                }}
                                                className="d-flex align-items-start gap-2 dropdown-permission-item"
                                            >
                                                <div className="tick-slot">
                                                    {selected === "view" && <IconCheck size={18} stroke={3} />}
                                                </div>
                                                <div className="pt-1 text-secondary">
                                                    <IconEye stroke={2} size={18} />
                                                </div>
                                                <div className="d-flex flex-column align-items-start">
                                                    <span className="fw-bold" style={{ fontSize: '13px' }}>Can View</span>
                                                    <small className="text-muted" style={{ fontSize: '11px' }}>Read-only access.</small>
                                                </div>
                                            </Dropdown.Item>

                                            {/* Edit Option */}
                                            <Dropdown.Item
                                                active={selected === "edit"}
                                                onClick={() => {
                                                    updatePermission(user.id, "edit");
                                                    setOpenDropdown(null);
                                                }}
                                                className="d-flex align-items-start gap-2 dropdown-permission-item"
                                            >
                                                <div className="tick-slot">
                                                    {selected === "edit" && <IconCheck size={18} stroke={3} />}
                                                </div>
                                                <div className="pt-1 text-secondary">
                                                    <IconPencil stroke={2} size={18} />
                                                </div>
                                                <div className="d-flex flex-column align-items-start">
                                                    <span className="fw-bold" style={{ fontSize: '13px' }}>Can Edit</span>
                                                    <small className="text-muted" style={{ fontSize: '11px' }}>Full modify access.</small>
                                                </div>
                                            </Dropdown.Item>

                                            {/* Download Restriction Option */}
                                            <Dropdown.Item
                                                active={selected === "download"}
                                                onClick={() => {
                                                    updatePermission(user.id, "download");
                                                    setOpenDropdown(null);
                                                }}
                                                className="d-flex align-items-start gap-2 dropdown-permission-item"
                                            >
                                                <div className="tick-slot">
                                                    {selected === "download" && <IconCheck size={18} stroke={3} />}
                                                </div>
                                                <div className="pt-1 text-secondary">
                                                    <IconDownloadOff stroke={2} size={18} />
                                                </div>
                                                <div className="d-flex flex-column align-items-start">
                                                    <span className="fw-bold" style={{ fontSize: '13px' }}>Can't Download</span>
                                                    <small className="text-muted" style={{ fontSize: '11px' }}>Full access, no export.</small>
                                                </div>
                                            </Dropdown.Item>

                                            <hr className="my-2 mx-3 text-muted opacity-25" />

                                            {/* Add a Remove Access option for better management */}
                                            <Dropdown.Item
                                                className="d-flex align-items-center gap-2 py-2 px-3 text-danger"
                                                style={{ fontSize: '13px', fontWeight: '500' }}
                                                onClick={async () => {
                                                    const updatedUsers = users.filter(u => u.id !== user.id);
                                                    setUsers(updatedUsers);
                                                    setOpenDropdown(null);
                                                    await handleRemoveAccess(updatedUsers);
                                                }}
                                            >
                                                <div className="tick-slot"></div>
                                                <IconTrash size={18} stroke={2} />
                                                <span>Remove Access</span>
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            );
                        })}
                        <style jsx>{`.current:hover{ background-color : #edf3f5 !important; color : #2c4881 !important; }`}</style>
                    </div>
                )}
            </Modal.Body>

            {/* --- UPDATED FOOTER --- */}
            <Modal.Footer className={`border-top-0 px-4 pb-4 pt-2 d-flex align-items-center ${shareForm ? "justify-content-between" : "justify-content-end"}`}>
                {shareForm && (
                    <div
                        className="d-flex align-items-center cursor-pointer"
                        onClick={() => setShareForm(false)}
                        style={{ transition: 'opacity 0.2s' }}
                        onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'}
                        onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                    >
                        <div className="d-flex align-items-center">
                            {/* Logic: Show individual icons if 2 or fewer, otherwise show stack with +N */}
                            {users?.length <= 2 ? (
                                users?.map((user, index) => (
                                    <div
                                        key={user.id}
                                        className="bg-light rounded-circle d-flex align-items-center justify-content-center border border-white shadow-sm"
                                        style={{
                                            width: "28px",
                                            height: "28px",
                                            marginLeft: index > 0 ? "-8px" : "0",
                                            zIndex: 10 - index
                                        }}
                                    >
                                        <IconUser size={14} color="#7a3a5e" />
                                    </div>
                                ))
                            ) : (
                                <>
                                    <div className="bg-light rounded-circle d-flex align-items-center justify-content-center border border-white shadow-sm" style={{ width: "28px", height: "28px", zIndex: 3 }}>
                                        <IconUser size={14} color="#7a3a5e" />
                                    </div>
                                    <div className="bg-light rounded-circle d-flex align-items-center justify-content-center border border-white shadow-sm" style={{ width: "28px", height: "28px", marginLeft: "-10px", zIndex: 2 }}>
                                        <IconUser size={14} color="#7a3a5e" />
                                    </div>
                                    <div
                                        className="rounded-circle d-flex align-items-center justify-content-center border border-white fw-bold shadow-sm"
                                        style={{
                                            width: "28px",
                                            height: "28px",
                                            marginLeft: "-10px",
                                            zIndex: 1,
                                            backgroundColor: "#f0f0f0",
                                            fontSize: "10px",
                                            color: "#7a3a5e"
                                        }}
                                    >
                                        +{users.length - 2}
                                    </div>
                                </>
                            )}

                            {/* Fallback for when no one has access yet */}
                            {(!users || users.length === 0) && (
                                <div className="bg-light rounded-circle d-flex align-items-center justify-content-center border border-white" style={{ width: "28px", height: "28px" }}>
                                    <IconUserPlus size={14} color="#64748b" />
                                </div>
                            )}
                        </div>
                        <span className="ms-2 fw-semibold" style={{ fontSize: '13px', color: '#64748b' }}>
                            {users?.length > 0 ? "Manage Access" : "No access yet"}
                        </span>
                    </div>
                )}

                <div className="d-flex gap-2">
                    <button
                        onClick={onShareClose}
                        className="px-3 py-2 fw-medium transition-all"
                        style={{
                            backgroundColor: "#ffffff",
                            color: "#7a3a5e",
                            border: "1px solid #7a3a5e",
                            fontSize: "13px",
                            borderRadius: "6px",
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        disabled={isSharing}
                        onClick={(e) => {
                            e.preventDefault();
                            handleSubmit();
                        }}
                        className="px-4 py-2 fw-semibold text-white shadow-sm transition-all"
                        style={{
                            backgroundColor: "#7a3a5e",
                            border: "none",
                            fontSize: "14px",
                            borderRadius: "6px",
                            opacity: isSharing ? 0.7 : 1
                        }}
                    >
                        {isSharing ? "Sharing..." : "Share Pipeline"}
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}
